;(function () {
	const portfolioGrid = document.querySelector( '.portfolio-grid' );

	if ( ! portfolioGrid ) {
		return;
	}

	const openedClass = 'portfolio-item--opened';
	const closeBtnClass = 'btn--close';

	portfolioGrid.addEventListener( 'click', e => {
		const portfolioItem = e.target.closest( 'article' );

		if ( ! portfolioItem ) {
			return true;
		}

		if ( ! e.target.closest( '.portfolio-popup' ) ) {
			e.preventDefault();
			open( portfolioItem );
		}
	});

	portfolioGrid.querySelectorAll( `.${closeBtnClass}` ).forEach( btn => {
		btn.addEventListener( 'click', e => {
			e.preventDefault();
			close( e.target.closest( `.${openedClass}` ) );
		});
	});

	portfolioGrid.querySelectorAll( '.portfolio-popup' ).forEach( popup => {
		popup.addEventListener( 'click', e => {
			if ( ! e.target.closest( '.portfolio-popup__inner' ) ) {
				close( e.target.closest( `.${openedClass}` ) );
			}
		});
	});

	function open( elem ) {
		// window.history.replaceState(
		// 	"",
		// 	elem.querySelector( '.portfolio-item__title' ).innerText,
		// 	window.location.pathname + '#' + elem.querySelector( '.portfolio-popup' ).id
		// );
		window.requestAnimationFrame( () => {
			elem.querySelector( `.${closeBtnClass}` );
			elem.classList.add( openedClass )
		});
	}

	function close( elem ) {
		// window.location.hash = '0';
		// window.history.replaceState(
		// 	"",
		// 	document.title,
		// 	window.location.pathname + window.location.search
		// );

		window.requestAnimationFrame( () => { elem.classList.remove( openedClass ) } );
	}
}());
